// extracted by mini-css-extract-plugin
module.exports = {"hackathonPage":"Hackathon_hackathonPage__17oGx","hackathonBanner":"Hackathon_hackathonBanner__Ti1h2","ctaButton":"Hackathon_ctaButton___-l6N"};